import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app'; 

@Injectable({
  providedIn: 'root'
})
export class SocialService {

  constructor( public auth:AngularFireAuth ) {

    // auth.authState.subscribe( user => {
    //   console.log('authState Suscriber:', user)
    // })
  }

  title = 'login';

  loginWithSocialProvider(provider, email?, password? ):Promise<firebase.auth.UserCredential>{
    switch(provider){
      case 'google':
        return this.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
        break;
      case 'facebook':
        return this.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider());
        break;
      case 'email':
        return this.auth.signInWithEmailAndPassword(email, password);
        break;


      case 'registraremail':
        return this.auth.createUserWithEmailAndPassword(email, password);
        break;
    }
  }

  linkWithSocialProvider(provider):Promise<firebase.auth.UserCredential>{
    switch(provider){
      case 'google':
        return firebase.auth().currentUser.linkWithPopup(new firebase.auth.GoogleAuthProvider());
        break;
      case 'facebook':
        return firebase.auth().currentUser.linkWithPopup(new firebase.auth.FacebookAuthProvider());
        break;
    }
  }


  enviarCorreoVerificacion(){
    this.auth.currentUser.then( user => {
      if(user){
        user.sendEmailVerification();
      }
    });
  }

  obtenerTokenUsuario(){
    return this.auth.currentUser;
  }

  obtenerUsuarioActual(){
    return this.auth.currentUser;
  }

  obtenerProviderUsuarioActual(){
    return firebase.auth().currentUser.providerData;
  }

  eliminarProveedor(proveedor){
    return firebase.auth().currentUser.unlink(proveedor);
  }

  refreshToken(){
    return firebase.auth().currentUser.refreshToken;
  }


  reAutenticarUsuario():Promise<firebase.auth.IdTokenResult>{
    return firebase.auth().currentUser.getIdTokenResult(true);
  }



  deleteUser(){

    return firebase.auth().currentUser.getIdTokenResult(true).then( () => {
      this.auth.authState.subscribe( user => {
        user.delete().then( res =>{
        }).catch( err =>{
          console.error(err)
        })
      })
    }); 
  }












  




  obtenerProvider(){
    return this.auth.authState.subscribe( user => {
      user.providerId;

    })
  }

  

 

  logout(){
    this.auth.signOut()
  }
}
